 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-order-lookup-page-order-lookup-page-module-ngfactory":"pages-order-lookup-page-order-lookup-page-module-ngfactory","default~pages-become-seller-page-become-seller-page-module-ngfactory~pages-enter-shipping-page-enter~39d323df":"default~pages-become-seller-page-become-seller-page-module-ngfactory~pages-enter-shipping-page-enter~39d323df","default~pages-my-orders-page-my-orders-page-module-ngfactory~seller-dashboard-seller-dashboard-modul~fb914160":"default~pages-my-orders-page-my-orders-page-module-ngfactory~seller-dashboard-seller-dashboard-modul~fb914160","seller-dashboard-seller-dashboard-module-ngfactory":"seller-dashboard-seller-dashboard-module-ngfactory","pages-become-seller-page-become-seller-page-module-ngfactory":"pages-become-seller-page-become-seller-page-module-ngfactory","pages-enter-shipping-page-enter-shipping-page-module-ngfactory":"pages-enter-shipping-page-enter-shipping-page-module-ngfactory","default~pages-file-dispute-page-file-dispute-page-module-ngfactory~pages-order-details-page-order-de~e4231eb8":"default~pages-file-dispute-page-file-dispute-page-module-ngfactory~pages-order-details-page-order-de~e4231eb8","pages-file-dispute-page-file-dispute-page-module-ngfactory":"pages-file-dispute-page-file-dispute-page-module-ngfactory","pages-order-details-page-order-details-page-module-ngfactory":"pages-order-details-page-order-details-page-module-ngfactory","pages-my-orders-page-my-orders-page-module-ngfactory":"pages-my-orders-page-my-orders-page-module-ngfactory","default~pages-product-detail-page-product-detail-page-module-ngfactory~pages-seller-profile-page-sel~3a4316a1":"default~pages-product-detail-page-product-detail-page-module-ngfactory~pages-seller-profile-page-sel~3a4316a1","pages-product-detail-page-product-detail-page-module-ngfactory":"pages-product-detail-page-product-detail-page-module-ngfactory","pages-seller-profile-page-seller-profile-page-module-ngfactory":"pages-seller-profile-page-seller-profile-page-module-ngfactory","default~pages-review-order-page-review-order-page-module-ngfactory~pages-shopping-cart-page-shopping~5068f8cc":"default~pages-review-order-page-review-order-page-module-ngfactory~pages-shopping-cart-page-shopping~5068f8cc","pages-review-order-page-review-order-page-module-ngfactory":"pages-review-order-page-review-order-page-module-ngfactory","pages-shopping-cart-page-shopping-cart-page-module-ngfactory":"pages-shopping-cart-page-shopping-cart-page-module-ngfactory","pages-about-page-about-page-module-ngfactory":"pages-about-page-about-page-module-ngfactory","pages-faq-page-faq-page-module-ngfactory":"pages-faq-page-faq-page-module-ngfactory","pages-help-center-page-help-center-page-module-ngfactory":"pages-help-center-page-help-center-page-module-ngfactory","pages-info-page-info-page-module-ngfactory":"pages-info-page-info-page-module-ngfactory","pages-my-profile-page-my-profile-page-module-ngfactory":"pages-my-profile-page-my-profile-page-module-ngfactory","pages-order-placed-page-order-placed-page-module-ngfactory":"pages-order-placed-page-order-placed-page-module-ngfactory","pages-seller-account-registered-seller-account-registered-module-ngfactory":"pages-seller-account-registered-seller-account-registered-module-ngfactory","pages-seller-agreement-page-seller-agreement-page-module-ngfactory":"pages-seller-agreement-page-seller-agreement-page-module-ngfactory","pages-wedding-colors-wedding-colors-page-module-ngfactory":"pages-wedding-colors-wedding-colors-page-module-ngfactory"}[chunkId]||chunkId) + "." + {"common":"1c76dd10c578a347498b","pages-order-lookup-page-order-lookup-page-module-ngfactory":"931e3ddfa4799732c111","default~pages-become-seller-page-become-seller-page-module-ngfactory~pages-enter-shipping-page-enter~39d323df":"d98f4087cc504a17c329","default~pages-my-orders-page-my-orders-page-module-ngfactory~seller-dashboard-seller-dashboard-modul~fb914160":"9a5b0ef1926c2192992e","seller-dashboard-seller-dashboard-module-ngfactory":"559911617d772fb6b48a","pages-become-seller-page-become-seller-page-module-ngfactory":"8046da774d5e1794eb7c","pages-enter-shipping-page-enter-shipping-page-module-ngfactory":"4861a59afc47476e7cdb","default~pages-file-dispute-page-file-dispute-page-module-ngfactory~pages-order-details-page-order-de~e4231eb8":"7d8fc3400a56be68463f","pages-file-dispute-page-file-dispute-page-module-ngfactory":"a2069fbad4c6fe8dfa38","pages-order-details-page-order-details-page-module-ngfactory":"b51063e6d8174b9150bf","pages-my-orders-page-my-orders-page-module-ngfactory":"4a791a618e1dc6e4cbec","default~pages-product-detail-page-product-detail-page-module-ngfactory~pages-seller-profile-page-sel~3a4316a1":"e550daf7c4b50387bd79","pages-product-detail-page-product-detail-page-module-ngfactory":"9013fe2b57a7ec2fdb7a","pages-seller-profile-page-seller-profile-page-module-ngfactory":"76e5e72ef377174a3483","default~pages-review-order-page-review-order-page-module-ngfactory~pages-shopping-cart-page-shopping~5068f8cc":"bbbdcd55c4b6b74424eb","pages-review-order-page-review-order-page-module-ngfactory":"7a56cbd7a2121615b6ae","pages-shopping-cart-page-shopping-cart-page-module-ngfactory":"84c3e1008787b2f87907","pages-about-page-about-page-module-ngfactory":"57b66cdaf458ad208218","pages-faq-page-faq-page-module-ngfactory":"3302525f1dbd7ba73ebe","pages-help-center-page-help-center-page-module-ngfactory":"5bb6607044ca081d386f","pages-info-page-info-page-module-ngfactory":"bdc2e77cedd9e2983653","pages-my-profile-page-my-profile-page-module-ngfactory":"c6aecbebb1031a105d7e","pages-order-placed-page-order-placed-page-module-ngfactory":"3217d9975553414d1252","pages-seller-account-registered-seller-account-registered-module-ngfactory":"b82a8f4184cfa5f245d5","pages-seller-agreement-page-seller-agreement-page-module-ngfactory":"890dec59429153640645","pages-wedding-colors-wedding-colors-page-module-ngfactory":"b7713b9195bf3fae12ed"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
